// extracted by mini-css-extract-plugin
module.exports = {"block":"styles-module__block___t5YB8","is_open":"styles-module__is_open___GcxJ8"};